<template>
	<div>
		<section style="padding:20px;">

			<h1 class="h4">Modal Form Test Component</h1>

			<p>
				<a href="javascript:void(0)" @click="showModal()">Show Modal</a><br>

				<label for="wideModal" class="c-input c-checkbox-sm">
					<input type="checkbox" v-model="wideModal" id="wideModal">
					<span class="c-indicator"></span>Wide Modal
				</label>
			</p>

			<div style="font-size:11px;">
				<pre>{{ formData }}</pre>
			</div>

		</section>
		<Modal ref="testModal" ariaLabelled="modalTestComponentTitle" :wideModal="wideModal">
			<template #title>Modal Form Test</template>
			<template #default>
				<Forms ref="testForm" :formDefinition="formDefinition"/>
			</template>
			<template #footer>
				<button type="button" class="btn btn-primary" @click="saveForm()">Save</button>
				<button type="button" class="btn btn-primary" @click="closeModal()">Close</button>
			</template>
		</Modal>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import Modal from '@/components/schreg-common/Modal.vue';
import Forms from '@/components/schreg-common/Forms/Forms.vue';
import { baseComponentMixin } from '@/mixins/baseComponent.mixin';

export default defineComponent({
	name: 'ModalTestComponent',
	config: {
		key: 'schreg.testModal',
		devPath: 'modal-test',
		exported: false
	},
	components: {
		Modal,
		Forms
	},
	mixins: [
		baseComponentMixin
	],
	data() {
		return {
			formData: [],
			formDefinition: [
				{
					groupName: 'Name',
					fields: [
						{
							type: 'text',
							fieldName: 'firstName',
							fieldPrompt: 'First Name'
						},
						{
							type: 'text',
							fieldName: 'lastName',
							fieldPrompt: 'Last Name'
						}
					]
				},
				{
					groupName: 'Address',
					fields: [
						{
							type: 'text',
							fieldName: 'address1',
							fieldPrompt: 'Address 1'
						},
						{
							type: 'text',
							fieldName: 'address2',
							fieldPrompt: 'Address 2',
							required: false
						},
						{
							type: 'text',
							fieldName: 'cityStateZip',
							fieldPrompt: 'City / State / Zip'
						}
					]
				}
			],
			wideModal: false
		};
	},
	methods: {
		showModal() {
			this.$refs.testModal.show();
		},
		closeModal() {
			this.$refs.testModal.hide();
		},
		saveForm() {
			if (this.$refs.testForm.validate()) {
				this.formData.push(this.$refs.testForm.values());
				this.closeModal();
			}
		}
	}
});
</script>
